import React, { ReactElement, memo } from 'react'
import { Link } from 'gatsby'
import './ArticleCard.scss'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { GatsbyImage, ImageDataLike, getImage } from 'gatsby-plugin-image'

export type ArticleCardTypes = {
  title: string
  category: string
  slug: string
  featuredImage: string
  datePublished: string
  optimizedFeaturedImg: ImageDataLike
}

type ArticleCardPropTypes = {
  data: ArticleCardTypes
  url: string
  className?: string
}

const ArticleCard = ({
  data,
  url,
  className,
}: ArticleCardPropTypes): ReactElement => {
  return (
    <Link to={url} className="article-card-link">
      <div className={`article-card${className ? ` ${className}` : ''}`}>
        <div className="article-card-header">
          <div
            style={{
              background:
                'linear-gradient(179deg, rgba(0,0,0,0.00) 58%, #000000 100%)',
              position: 'absolute',
              top: '0',
              left: '0',
              width: '100%',
              height: '100%',
            }}
          />
          {data?.optimizedFeaturedImg && getImage(data.optimizedFeaturedImg) ? (
            <GatsbyImage
              image={getImage(data.optimizedFeaturedImg)!}
              alt="featured image"
            />
          ) : data?.featuredImage ? (
            <LazyLoadImage 
              src={data.featuredImage} 
              alt="featured image" 
              width="100%"
              height="100%"
            />
          ) : (
            <div style={{ 
              width: '100%', 
              height: '200px', 
              backgroundColor: '#f0f0f0',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <span>No image available</span>
            </div>
          )}
          <span className="type">{data.category}</span>
        </div>
        <div className="article-card-details">
          <h3>{data.title}</h3>
          <p>{data.datePublished}</p>
        </div>
      </div>
    </Link>
  )
}

export default memo(ArticleCard)
